// Inicializa o styled do MUI no boot (evita styled_default is not a function no x-charts).
import "@mui/material/styles/styled";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { register } from "./serviceWorker";
import { startTransition } from "react";

// Configuração global do React Router
React.startTransition = startTransition;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
